import { Link } from 'react-aria-components';
import type { ReactElement } from 'react';
import { sectionPath, type NavSection } from '../app/nav';
import { SectionIcon } from './SectionIcon';

/**
 * The phone navigation: every section as an icon over its label, fixed to the
 * bottom edge below `md`, where the sidebar and rail are hidden. The current
 * section's icon sits in the amber pill the sidebar uses for its current link.
 * Workspace and account stay in the top bar's menu (the overlay sidebar).
 */
export function TabBar({
  workspaceId,
  sections,
  activeSection
}: {
  workspaceId: string;
  sections: NavSection[];
  activeSection: string | null;
}): ReactElement {
  return (
    <nav
      aria-label="Sections"
      className="md:hidden fixed inset-x-0 bottom-0 z-bar m-0 p-0 border-0 border-t border-solid border-line bg-surface font-ui pb-safe"
    >
      <ul className="m-0 p-0 list-none grid grid-flow-col auto-cols-fr">
        {sections.map((s) => (
          <li key={s.id} className="m-0 p-0">
            <Link
              href={sectionPath(s, workspaceId)}
              aria-current={s.id === activeSection ? 'page' : undefined}
              className="group flex flex-col items-center justify-center gap-1 min-h-tab px-1 py-1 no-underline text-muted text-xs current:text-ink current:font-semibold focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-ink"
            >
              <span className="inline-flex items-center justify-center w-tab-pill h-7 rounded-pill group-current:bg-fill group-current:text-on-fill">
                <SectionIcon name={s.icon} />
              </span>
              <span className="truncate max-w-full">{s.label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
